<template>
  <AppFundamental />
</template>

<script setup>
import AppFundamental from './AppFundamental.vue';
</script>
